import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwissprot = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: " 0 0 40 40",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M36.57 14.2v25.22H17.85l-1.7-10 7.2-7.07-9.96-1.47-4.45-9.1-3.6 7.36V.98h18.01v13.21h13.22zM17.85 39.42H5.33v-2.81l3.6-1.91 8.92 4.72z" }),
		/* @__PURE__ */ _jsx("path", { d: "M25.76 11.79h10.81L25.76.98v10.8z" }),
		/* @__PURE__ */ _jsx("path", {
			className: "star",
			d: "M8.94 18.44l2.6 5.27 5.8.85-4.2 4.1 1 5.79-5.2-2.74-5.2 2.74 1-5.8-4.21-4.1 5.81-.84 2.6-5.27z"
		})
	]
});
export default SvgSwissprot;
